import React from "react";
import SubstanceInfo from "./SubstanceInfo";
// import SubstanceMegamix from "./SubstanceMegamix";
// import SubstanceUniverse from "./SubstanceUniverse";
import SubstanceInfoBasic from "./SubstanceInfoBasic"; // Import SubstanceInfoBasic

// import Chatbot from "./Chatbot";

const style = {
  name: { fontSize: 20, marginBottom: 22 },
  centered: { textAlign: "center" }
};

export default class Substance extends React.Component {
  render() {
    const { substance } = this.props;

    return (
      <div>
        <SubstanceInfo substance={substance} />
        {/* Przekazujemy substance do SubstanceInfoBasic */}
        <SubstanceInfoBasic substance={substance} /> 
        {/* <Chatbot substance={substance} /> */}
        {/* <SubstanceMegamix substance={substance} /> */}
        {/* <SubstanceUniverse substance={substance} /> */}
      </div>
    );
  }
}